"use client"

import React from "react"

import isExternalUrl from "@/helpers/isExternalUrl"
import { AllFeaturedCardsProps } from "@/types/events"

import BackgroundImage from "../BackgroundImage"
import Button from "../Button"
import FullWidthCarousel from "../FullWidthCarousel"
import PageGrid from "../PageGrid"

const AllFeaturedCards: React.FC<AllFeaturedCardsProps> = ({
  data,
  ...sectionProps
}) => (
  <section className="py-8 md:py-12 lg:py-16 xl:py-22" {...sectionProps}>
    <FullWidthCarousel
      showNavigation={data.length > 1}
      navigationClassName="mt-8"
    >
      {data.map(({ eventImage, title, description, buttonCta, buttonUrl }) => (
        <div key={title} className="embla__slide flex-[0_0_100%] min-w-0">
          <PageGrid>
            <BackgroundImage
              className="w-full h-full p-4 bg-cover rounded-lg col-span-full md:p-8 xl:p-16 lg:p-12"
              image={eventImage.url}
              key={title}
            >
              <div className="max-w-[460px] text-white-100">
                <h6 className="mb-4 caption3 lg:caption2 xl:caption3 xl:mb-12 lg:mb-10 md:mb-8">
                  Featured
                </h6>
                <h4 className="mb-4 lg:mb-6 headline4 md:headline3 lg:headline2 xl:headline1">
                  {title}
                </h4>
                <p className="mb-10 body3 xl:body2 xl:mb-12">{description}</p>
                <div className="min-h-[48px] flex items-start">
                  {buttonCta && buttonUrl && (
                    <Button
                      to={buttonUrl}
                      target={isExternalUrl(buttonUrl) ? "_blank" : undefined}
                    >
                      {buttonCta}
                    </Button>
                  )}
                </div>
              </div>
            </BackgroundImage>
          </PageGrid>
        </div>
      ))}
    </FullWidthCarousel>
  </section>
)

export default AllFeaturedCards
